<template>
  <main v-if="$page">
    <PageHeader :content="$page.header" />
    <ImageCTASection
      :content="$page.description"
      :link="$page.description_link"
      :page="$page.description_page"
    />
    <IconCardsSection :content="$page.benefits" />
    <ImageCTASection
      :content="$page.talents"
      :link="$page.talents_link"
      :page="$page.talents_page"
      reverse
    />
    <ImageCardsSection :content="{ ...$page.jobs, items: Object.values($beet.jobs) }" />
    <CTASection
      :content="$page.contact"
      :link="$page.contact_link"
      :page="$page.contact_page"
      class="--light"
    />
  </main>
</template>

<script>
import CTASection from '@/components/sections/CTASection.vue'
import IconCardsSection from '@/components/sections/IconCardsSection.vue'
import ImageCardsSection from '@/components/sections/ImageCardsSection.vue'
import ImageCTASection from '@/components/sections/ImageCTASection.vue'
import PageHeader from '@/components/sections/PageHeader.vue'
import PageMetaMixin from '@/mixins/PageMetaMixin.js'

export default {
  name: 'Careers',
  beetPage: 'careers',
  mixins: [PageMetaMixin],
  components: { CTASection, IconCardsSection, ImageCardsSection, ImageCTASection, PageHeader },
}
</script>
